export default __webpack_public_path__ + "static/media/Lost_Found.5777fb03.jpg";